import SEOHead from "@/components/base/SEOHead";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import AveriasFrecuentesSection from "@/components/feature/AveriasFrecuentesSection";
import FAQSection from "@/components/feature/FAQSection";
import ComoTrabajamosSection from "@/components/feature/ComoTrabajamosSection";
import Breadcrumb from "@/components/feature/Breadcrumb";
import PricingSection from "@/components/feature/PricingSection";
import TrustBannerSection from "@/components/feature/TrustBannerSection";
import { preciosPorServicio } from "@/mocks/precios";

export default function PersianasPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead
        title="Reparación de Persianas Málaga | Persianas Málaga"
        description="Reparación de persianas en Málaga: cambio de cintas, recogedores, lamas y motorización. Todas las marcas. Urgente 24-48h, presupuesto gratis, 2 años garantía."
      />
      <Navbar />

      <Breadcrumb items={[
        { label: "Inicio", path: "/" },
        { label: "Servicios" },
        { label: "Persianas" },
      ]} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Reparación de Persianas en Málaga",
        "provider": { "@type": "LocalBusiness", "name": "Persianas Málaga", "telephone": "+34 951 12 07 70" },
        "areaServed": "Málaga capital",
        "description": "Reparación de persianas en Málaga: cambio de cintas, recogedores, muelles, lamas y motorización. Todas las marcas. Servicio urgente 24-48h. Presupuesto gratis.",
        "serviceType": "Reparación de Persianas",
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Servicios de reparación de persianas",
          "itemListElement": [
            { "@type": "Offer", "name": "Cambio de cinta de persiana", "price": "45", "priceCurrency": "EUR" },
            { "@type": "Offer", "name": "Reparación persiana atascada", "price": "50", "priceCurrency": "EUR" },
            { "@type": "Offer", "name": "Cambio de motor de persiana", "price": "120", "priceCurrency": "EUR" },
            { "@type": "Offer", "name": "Cambio de lamas", "price": "70", "priceCurrency": "EUR" }
          ]
        }
      }) }} />

      {/* Hero */}
      <section className="py-14 md:py-20 bg-gradient-to-br from-background-50 via-primary-50/30 to-accent-50/30">
        <div className="px-4 md:px-6 max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 md:gap-12 items-center">
            <div className="flex-1 w-full">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-foreground-950 mb-4 leading-tight font-heading">
                Reparación de persianas <span className="text-primary-500">en Málaga</span>
              </h1>
              <p className="text-sm md:text-lg text-foreground-600 mb-6 max-w-lg leading-relaxed">
                Cambio de cintas, recogedores, muelles, lamas y motorización. Todas las marcas. Servicio urgente 24-48h en los 16 barrios de Málaga capital. Presupuesto gratis, 2 años de garantía.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <a href="tel:+34951120770" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-background-50 font-bold text-sm md:text-base px-8 py-4 rounded-full transition-all active:scale-[0.98] whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/20">
                  <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill"></i></span>
                  951 12 07 70
                </a>
                <a href="https://wa.me/34627213347" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1faa52] text-white font-semibold text-sm md:text-base px-8 py-4 rounded-full transition-all active:scale-[0.98] whitespace-nowrap cursor-pointer">
                  <span className="w-5 h-5 flex items-center justify-center"><i className="ri-whatsapp-fill"></i></span>
                  WhatsApp
                </a>
              </div>
            </div>
            <div className="w-full lg:w-[45%] h-64 sm:h-80 md:h-96 rounded-2xl overflow-hidden flex-shrink-0">
              <img alt="Reparación profesional de persianas en Málaga" className="w-full h-full object-cover object-top" loading="eager" src="/images/008-serv-persianas-hero-v2.webp" />
            </div>
          </div>
        </div>
      </section>

      {/* Servicios detallados */}
      <section className="py-10 md:py-14 bg-background-100">
        <div className="px-4 md:px-6 max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 font-heading text-center">¿Qué reparamos de tu persiana?</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {[
              { icon: "ri-rotate-lock-line", title: "Cambio de cinta", desc: "Sustitución de cintas desgastadas, rotas o atascadas. Todo tipo de persianas: aluminio, PVC y madera. Rápido y limpio." },
              { icon: "ri-settings-3-line", title: "Recogedor y muelle", desc: "Reparación y cambio de recogedores y muelles. Si la persiana no sube o se queda a media altura, tiene arreglo." },
              { icon: "ri-layout-masonry-line", title: "Cambio de lamas", desc: "Sustitución de lamas dañadas, oxidadas o rotas. Lamas de aluminio, PVC y madera. Stock permanente de recambios." },
              { icon: "ri-remote-control-line", title: "Motorización", desc: "Instalación de motores eléctricos Somfy y Nice. Convierte tu persiana manual en motorizada sin necesidad de obras." },
              { icon: "ri-tools-line", title: "Persiana atascada", desc: "Desatasco de persianas bloqueadas. Reparación in situ en menos de una hora. Servicio urgente en todo Málaga." },
              { icon: "ri-building-line", title: "Persianas metálicas", desc: "Reparación de persianas metálicas en locales comerciales y garajes. Muelles de seguridad, cierre automático." },
            ].map((item) => (
              <div key={item.title} className="p-5 md:p-6 bg-background-50 rounded-2xl border border-background-200/60">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500/10 mb-3">
                  <span className="w-5 h-5 flex items-center justify-center"><i className={`${item.icon} text-primary-600 text-lg`}></i></span>
                </div>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <AveriasFrecuentesSection ids={["no-sube-ni-baja", "cinta-rota", "atascada-descolgada", "motor-no-funciona", "lamas-rotas", "motorizar"]} />

      {/* Guías relacionadas */}
      <section className="py-10 md:py-14 bg-background-50">
        <div className="px-4 md:px-6 max-w-4xl mx-auto text-center">
          <h3 className="text-lg md:text-xl font-bold text-foreground-950 mb-6 font-heading">Guías detalladas de reparación de persianas</h3>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/guias/como-cambiar-cinta-persiana" className="text-sm text-primary-600 hover:text-primary-700 underline cursor-pointer">Cómo cambiar la cinta</Link>
            <span className="text-foreground-300 select-none">|</span>
            <Link to="/guias/persiana-no-sube-ni-baja" className="text-sm text-primary-600 hover:text-primary-700 underline cursor-pointer">No sube ni baja</Link>
            <span className="text-foreground-300 select-none">|</span>
            <Link to="/guias/persiana-atascada-descolgada" className="text-sm text-primary-600 hover:text-primary-700 underline cursor-pointer">Atascada o descolgada</Link>
            <span className="text-foreground-300 select-none">|</span>
            <Link to="/guias/cambiar-motor-persiana" className="text-sm text-primary-600 hover:text-primary-700 underline cursor-pointer">Cambiar el motor</Link>
            <span className="text-foreground-300 select-none">|</span>
            <Link to="/guias/cambiar-lamas-persiana" className="text-sm text-primary-600 hover:text-primary-700 underline cursor-pointer">Cambiar lamas rotas</Link>
            <span className="text-foreground-300 select-none">|</span>
            <Link to="/guias/reparar-recogedor-persiana" className="text-sm text-primary-600 hover:text-primary-700 underline cursor-pointer">Reparar el recogedor</Link>
            <span className="text-foreground-300 select-none">|</span>
            <Link to="/guias/como-cambiar-cuerda-persiana" className="text-sm text-primary-600 hover:text-primary-700 underline cursor-pointer">Cambiar la cuerda</Link>
            <span className="text-foreground-300 select-none">|</span>
            <Link to="/guias" className="text-sm text-primary-600 hover:text-primary-700 underline cursor-pointer font-semibold">Ver todas las guías →</Link>
          </div>
        </div>
      </section>

      <PricingSection ids={preciosPorServicio["persianas"]} />

      <FAQSection
        title="Preguntas frecuentes sobre reparación de persianas"
        questions={[
          {
            question: "¿Cuánto cuesta reparar una persiana?",
            answer: "Depende de la avería. Cambiar una cinta: entre 40€ y 75€. Cambio de recogedor y muelle: entre 50€ y 90€. Sustitución de motor: entre 140€ y 280€ según modelo. Cambio de lamas sueltas: desde 12€ por lama. Reparación de persiana atascada: desde 45€. Son precios orientativos — el presupuesto exacto y cerrado te lo damos gratis tras revisar tu persiana en persona.",
          },
          {
            question: "¿Es mejor reparar mi persiana o cambiarla entera?",
            answer: "En el 90% de los casos, reparar es la mejor opción. Una persiana con cinta rota, recogedor dañado o incluso motor averiado se repara perfectamente sin necesidad de cambiar todo el sistema. Solo recomendamos el cambio completo cuando la persiana tiene más de 25 años, las lamas están muy deterioradas en conjunto, y la reparación saldría más cara que una persiana nueva. Te lo explicamos con total claridad en el diagnóstico gratuito.",
          },
          {
            question: "¿Cuánto tardáis en cambiar una cinta de persiana?",
            answer: "Un cambio de cinta estándar se hace en 30-45 minutos. Si además hay que cambiar el recogedor, unos 15 minutos más. Es un trabajo limpio, sin polvo ni escombros, y te dejamos la persiana funcionando antes de irnos. Siempre llevamos en la furgoneta todos los anchos y colores de cinta habituales, así que no hay que esperar a pedir piezas.",
          },
          {
            question: "¿Se puede motorizar una persiana manual sin hacer obras?",
            answer: "Sí, y es más sencillo de lo que la gente cree. Aprovechamos el cajetín y los soportes existentes. Instalamos un motor tubular del diámetro adecuado en menos de una hora. Sin polvo, sin romper nada, sin modificar la fachada. Te llevas el mando configurado y las instrucciones. Trabajamos con motores Somfy y Nice, las dos marcas líderes del mercado.",
          },
          {
            question: "¿Dais garantía en las reparaciones de persianas?",
            answer: "Sí, 2 años de garantía por escrito en todas nuestras reparaciones e instalaciones de persianas. Cubre tanto las piezas sustituidas (cinta, recogedor, muelle, motor, lamas) como la mano de obra. Si algo falla dentro de ese periodo, vuelves a llamarnos y lo arreglamos sin coste adicional. Es una garantía real, no de papel.",
          },
        ]}
      />

      <ComoTrabajamosSection />

      {/* Marcas */}
      <section className="py-10 md:py-14 bg-gradient-to-br from-background-50 via-primary-50/15 to-accent-50/20">
        <div className="px-4 md:px-6 max-w-7xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6 font-heading">Trabajamos con todas las marcas</h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8">Somfy, Nice, Bubendorff, Gaviota, Simu, Alutech, Griesser, Vental y todas las marcas del mercado. Recambios originales.</p>
          <div className="flex flex-wrap justify-center gap-4">
            {["Somfy", "Nice", "Bubendorff", "Gaviota", "Simu", "Alutech"].map((m) => (
              <span key={m} className="bg-background-100 text-foreground-700 font-semibold text-sm px-5 py-2.5 rounded-full border border-background-200/60">{m}</span>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-10 md:py-14 bg-gradient-to-r from-primary-500 to-primary-600">
        <div className="px-4 md:px-6 max-w-4xl mx-auto text-center">
          <h3 className="text-xl md:text-2xl font-bold text-background-50 mb-3 font-heading">¿Problemas con tu persiana? Llámanos</h3>
          <p className="text-sm md:text-base text-background-50/80 mb-6">Presupuesto gratis · Sin desplazamiento · Respuesta en 24-48h</p>
          <a href="tel:+34951120770" className="inline-flex items-center justify-center gap-2 bg-background-50 hover:bg-background-100 text-primary-600 font-semibold text-sm px-8 py-4 rounded-full transition-all whitespace-nowrap cursor-pointer">
            <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill text-base"></i></span>
            951 12 07 70
          </a>
        </div>
      </section>

      <TrustBannerSection />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}